import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons/faExclamationCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import * as React from "react";

interface IProps {
    children?: React.ReactNode;
}

type Props = IProps;

export const MprcDanger: React.FC<Props> = (props) => {
    const { children, ...rest } = props;
    return (
        <Box
            {...rest}
            component="span"
            sx={
                (theme) => (
                    {
                        fontSize: "small",
                        color: theme.palette["error"].main
                    }
                )
            }
        >
            <FontAwesomeIcon icon={faExclamationCircle} fixedWidth />
            {children}
        </Box>
    );
};
